<script setup lang="ts">
import { useScreenSize } from "@soft-db/ui";

const { mdOrLower } = useScreenSize();
</script>

<template>
	<slot v-if="!mdOrLower" />
</template>
